<template>
  <div class="card-box">
    <el-button v-create:contact="{customer_id: customer.id}" class="pull-right" type="success" size="mini" icon="el-icon-plus" circle></el-button>
    <h4 class="header-title m-t-0 m-b-20">Contacts</h4>
    <customer present="contacts" :item="customer"></customer>
  </div>
</template>

<script>
  import Customer from '../../../Entities/Customer.vue'

  export default {
    components: {Customer},
    name: 'customer-contacts-summary-widget',
    props: ['customer']
  }
</script>



// WEBPACK FOOTER //
// CustomerContactsSummaryWidget.vue?56e692fa